import Swiper from "swiper";

if (window.mobileMedia) {
    const promotionsSlider = document.querySelector(".js-promotions-slider-init");

    if (promotionsSlider) {
        const pagination = document.querySelector(".js-promotions-mini-pagintaion");

        new Swiper(promotionsSlider, {
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.24,
            watchOverflow: true,
            observer: true,
            preventClicks: false,
            breakpoints: {
                410: {
                    slidesPerView: 1.4,
                },
                460: {
                    slidesPerView: 1.7,
                },
                550: {
                    slidesPerView: 2,
                },
            },
            pagination: {
                el: pagination,
                clickable: true,
                dynamicMainBullets: 3,
                dynamicBullets: true,
            },
        });
    }
}
